import orderRequestSessionStorage from "./orderRequestSessionStorage";

const sessionStorage = orderRequestSessionStorage();
const storageRequests = sessionStorage.getItem({
  success: [],
  failed: []
});

export const orderRequestInitialState = {
  orderRequestKey: null,
  status: "pending", // pending, completed, requesting
  requests: {
    success: storageRequests?.success || [],
    failed: storageRequests?.failed || []
  },
  current: null,
  error: null
};

export default orderRequestInitialState;
